import _asyncToGenerator from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import './DAcApplicationUploadDocuments.css';
import React, { useEffect, useMemo, useState } from 'react';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import UploadDocs from '../UploadDocs/UploadDocs';
import { fileToBase64, get, getDictionaryItem, getSizeFromBase64 } from '../../utils';
import { RichText, Text } from '@sitecore-jss/sitecore-jss-react';
import { createMapFromDictionary } from '../../utils/createMapFromDictionary';
import ActionPanel from './ActionPanel';
import { getAdditionalDocs, resubmitApplication } from './actions';
import Cookies from 'js-cookie';
import { useHistory, useLocation } from 'react-router-dom';
import { UploadDocument } from '../DAcApplication/components/actions';
import { getSessionId } from '../DAcApplication/utils';
import Loader from '../atoms/Loader/Loader';
var DAcApplicationUploadDocuments = function DAcApplicationUploadDocuments(props) {
  var sitecoreContext = React.useContext(SitecoreContextReactContext);
  var history = useHistory();
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    docsListLoading = _useState2[0],
    setDocsListLoading = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    error = _useState4[0],
    setError = _useState4[1];
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    docs = _useState6[0],
    setDocs = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    buttonLoading = _useState8[0],
    setButtonLoading = _useState8[1];
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    buttonInactive = _useState10[0],
    setButtonInactive = _useState10[1];
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var title = get(props.fields, 'data.configuration.udTitle');
  var description = get(props.fields, 'data.configuration.udShortDescription');
  var supportedFiles = get(props.fields, 'data.configuration.udFileTypes.jss.value', '').split(',').filter(function (el) {
    return !!el;
  });
  var maxFileSizeStr = get(props.fields, 'data.configuration.udFileSize.jss.value', '');
  var apiKey = get(props.fields, 'data.settings.apiKey.jss.value', '');
  var apiUrl = get(props.fields, 'data.settings.apiUrl.jss.value', '');
  var buttonSubmitUrl = get(props.fields, 'data.configuration.buttonSubmitUrl.jss.value.href', '');
  var maxFileSize = maxFileSizeStr && !Number.isNaN(Number(maxFileSizeStr)) ? Number(maxFileSizeStr) : undefined;
  var dictionary = get(props.fields, 'data.dictionaryUploadDocument', []);
  var navDictionary = get(props.fields, 'data.dictionaryNavigation.dictionaryValues', []);
  var navMapDictionary = createMapFromDictionary(navDictionary);
  var submitText = navMapDictionary.get('NavigationSubmit') || '';
  var _useLocation = useLocation(),
    search = _useLocation.search;
  var userTokken = Cookies.get('token');
  var searchParams = new URLSearchParams(search);
  var applicationNumber = searchParams.get('appn');
  var sessionId = useMemo(function () {
    return getSessionId('additional-documents');
  }, []);
  var setErrorDoc = function setErrorDoc(doc, file, error) {
    setDocs(function (docs) {
      return docs.map(function (el) {
        if (el.documentTypeId === doc.documentTypeId) {
          return _objectSpread(_objectSpread({}, el), {}, {
            isLoading: false,
            FileName: file.name,
            isUploaded: false,
            MimeType: file.type,
            size: file.size,
            percent: 0,
            error: error
          });
        } else {
          return el;
        }
      });
    });
  };
  var setLoadingDoc = function setLoadingDoc(doc, file) {
    setDocs(function (docs) {
      return docs.map(function (el) {
        if (el.documentTypeId === doc.documentTypeId) {
          return _objectSpread(_objectSpread({}, el), {}, {
            isLoading: true,
            FileName: file.name,
            isUploaded: false,
            MimeType: file.type,
            percent: 0,
            size: file.size,
            error: ''
          });
        } else {
          return el;
        }
      });
    });
  };
  var setUpdatedDoc = function setUpdatedDoc(doc) {
    setDocs(function (docs) {
      return docs.map(function (el) {
        if (el.documentTypeId === doc.documentTypeId) {
          return _objectSpread(_objectSpread({}, el), {}, {
            isLoading: false,
            isUploaded: true,
            percent: 100
          });
        } else {
          return el;
        }
      });
    });
  };
  var getErrorMessage = function getErrorMessage(res) {
    return (res && res.desc && (sitecoreContext.language === 'en' ? res.desc.en : res.desc.ar)).replaceAll(',', '\n') || res && (res.statusText || res.type) || getDictionaryItem(dictionary, 'SomethingWentWrong') || 'Something went wrong';
  };
  var deleteDoc = function deleteDoc(doc) {
    setDocs(function (docs) {
      return docs.map(function (el) {
        if (el.documentTypeId === doc.documentTypeId) {
          return _objectSpread(_objectSpread({}, el), {}, {
            isLoading: false,
            FileName: undefined,
            isUploaded: false,
            MimeType: "",
            size: 0,
            percent: 0,
            error: undefined
          });
        } else {
          return el;
        }
      });
    });
  };
  var setProgress = function setProgress(doc, file, percent) {
    setDocs(function (docs) {
      return docs.map(function (el) {
        if (el.documentTypeId === doc.documentTypeId) {
          return _objectSpread(_objectSpread({}, el), {}, {
            isLoading: true,
            FileName: file.name,
            isUploaded: false,
            MimeType: file.type,
            percent: percent,
            size: file.size,
            error: ''
          });
        } else {
          return el;
        }
      });
    });
  };
  var onUpload = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(document, file) {
      var base64file, res;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return fileToBase64(file);
          case 2:
            base64file = _context.sent;
            setLoadingDoc(document, file);
            setButtonLoading(true);
            _context.prev = 5;
            _context.next = 8;
            return UploadDocument({
              apiKey: apiKey,
              apiUrl: apiUrl,
              sessionId: sessionId,
              userTokken: userTokken
            }, applicationNumber || '', {
              document: base64file,
              documentTypeId: document.documentTypeId,
              FileName: file.name,
              MimeType: file.type
            }, function (val) {
              return setProgress(document, file, val);
            });
          case 8:
            res = _context.sent;
            setButtonLoading(false);
            if (res.success === true) {
              setUpdatedDoc(document);
            } else {
              setErrorDoc(document, file, getErrorMessage(res));
            }
            _context.next = 17;
            break;
          case 13:
            _context.prev = 13;
            _context.t0 = _context["catch"](5);
            console.error(_context.t0);
            setErrorDoc(document, file, getDictionaryItem(dictionary, 'NetworkError') || 'Network error');
          case 17:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[5, 13]]);
    }));
    return function onUpload(_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
  var onUploadFileError = function onUploadFileError(document, file, error) {
    setErrorDoc(document, file, getDictionaryItem(dictionary, error) || error);
  };
  var onSubmit = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var res, IsValid;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return resubmitApplication({
              apiKey: apiKey,
              apiUrl: apiUrl,
              sessionId: sessionId,
              userTokken: userTokken
            }, applicationNumber || '');
          case 2:
            res = _context2.sent;
            IsValid = res.IsValid;
            if (IsValid === 'True') history.push(buttonSubmitUrl);else getErrorMessage(res);
          case 5:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function onSubmit() {
      return _ref2.apply(this, arguments);
    };
  }();
  useEffect(function () {
    var invaliddoc = docs.find(function (_ref3) {
      var IsMandatory = _ref3.IsMandatory,
        isUploaded = _ref3.isUploaded;
      return IsMandatory && !isUploaded;
    });
    setButtonInactive(!!invaliddoc);
  }, [docs]);
  useEffect(function () {
    if (!applicationNumber) {
      return;
    }
    var load = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var res;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              setDocsListLoading(true);
              _context3.prev = 1;
              _context3.next = 4;
              return getAdditionalDocs({
                apiKey: apiKey,
                apiUrl: apiUrl,
                sessionId: sessionId,
                userTokken: userTokken
              }, applicationNumber);
            case 4:
              res = _context3.sent;
              if (res.status === 200) {
                setDocs(get(res, 'DocumentsList', []));
              } else {
                setError(getErrorMessage(res));
              }
              _context3.next = 11;
              break;
            case 8:
              _context3.prev = 8;
              _context3.t0 = _context3["catch"](1);
              setError(getDictionaryItem(dictionary, 'NetworkError') || 'Network, error');
            case 11:
              setDocsListLoading(false);
            case 12:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[1, 8]]);
      }));
      return function load() {
        return _ref4.apply(this, arguments);
      };
    }();
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl
  }, /*#__PURE__*/React.createElement("div", {
    className: "dac-application-upload-documents"
  }, /*#__PURE__*/React.createElement("div", {
    className: "dac-application-upload-documents__module-group"
  }, /*#__PURE__*/React.createElement("div", {
    className: "dac-application-upload-documents__module-header"
  }, /*#__PURE__*/React.createElement(Text, {
    className: "dac-application-upload-documents__title",
    tag: "h2",
    field: title.jss
  }), /*#__PURE__*/React.createElement(RichText, {
    className: "dac-application-upload-documents__description",
    tag: "p",
    field: description.jss
  })), docs.map(function (doc) {
    return /*#__PURE__*/React.createElement("div", {
      key: doc.documentTypeId,
      className: "dac-application-upload-documents__white-wrapper"
    }, /*#__PURE__*/React.createElement(UploadDocs, {
      onChange: function onChange(file) {
        return onUpload(doc, file);
      },
      dragNdropText: getDictionaryItem(dictionary, 'UploadFilesForEachPage'),
      fileUploadDescription: getDictionaryItem(dictionary, 'ApplicantsPassportMessage'),
      fileUploadTitle: "".concat(sitecoreContext.language === 'ar' ? doc.documentNameAr : doc.documentNameEn, " ").concat(doc.IsMandatory ? ' *' : ''),
      files: doc.FileName ? [{
        id: doc.documentTypeId,
        filename: doc.FileName,
        size: doc.size || (doc.document ? getSizeFromBase64(doc.document) : undefined),
        error: doc.error,
        isLoading: doc.isLoading,
        isUploaded: doc.isUploaded,
        percent: doc.percent
      }] : [],
      successMessage: getDictionaryItem(dictionary, 'FileUploadedSuccessfully'),
      uploadButtonLabel: getDictionaryItem(dictionary, 'ChooseFile'),
      maxSizeKb: maxFileSize,
      onError: function onError(error, file) {
        return onUploadFileError(doc, file, error);
      },
      maxSizeLabel: getDictionaryItem(dictionary, 'MaximumSize'),
      supportedFormatsLabel: getDictionaryItem(dictionary, 'SupportedFormat'),
      supportedFormats: supportedFiles,
      onDelete: function onDelete() {
        return deleteDoc(doc);
      }
    }));
  }), error && /*#__PURE__*/React.createElement("div", {
    className: "dac-application-upload-documents__white-wrapper error-message"
  }, error)), docsListLoading && /*#__PURE__*/React.createElement(Loader, null)), /*#__PURE__*/React.createElement(ActionPanel, {
    isLoading: docs.some(function (el) {
      return el.isLoading;
    }) || buttonLoading,
    submitText: submitText,
    inactive: buttonInactive,
    onSubmit: onSubmit
  }));
};
export default DAcApplicationUploadDocuments;
var StyledWrapper = function StyledWrapper(_ref5) {
  var children = _ref5.children,
    rtl = _ref5.rtl;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles)
  }, children);
};
var commonStyles = "c1t6m5ps";
var rtlStyles = "r1fu83kp";
var ltrStyles = "l1itqgxi";